import { joinPresent, initialsFromName } from '../mentorDashboardFormat';
import type { MenteeMentorProfilePayload } from './MenteePortalService';

type Props = {
    payload: MenteeMentorProfilePayload;
    onSendMessage: () => void;
};

const MenteeMyMentorHeader = ({ payload, onSendMessage }: Props) => {
    const { identity, cohort } = payload;
    const name = identity.name || 'Your mentor';
    const roleLine = joinPresent([identity.designation, identity.company]);
    const chips = [
        identity.batchYear != null ? `Batch ${identity.batchYear}` : null,
        identity.programName,
        identity.experienceYears != null && identity.experienceYears > 0
            ? `${identity.experienceYears} years of experience`
            : null,
    ].filter(Boolean) as string[];
    const cohortBit = cohort?.name
        ? `Assigned for Cohort ${cohort.name}`
        : joinPresent([cohort?.startDate, cohort?.endDate], ' – ')
          ? `Assigned for Cohort ${joinPresent([cohort?.startDate, cohort?.endDate], ' – ')}`
          : null;
    const subtitle = joinPresent([name, cohortBit]);

    return (
        <>
            <div className="d-flex flex-wrap align-items-start justify-content-between mb-4 gap-3">
                <div>
                    <h4 className="font-22 font-600 mb-1 text-dark">My Mentor</h4>
                    <div className="text-secondary small">{subtitle ? <span>{subtitle}</span> : null}</div>
                </div>
                <div className="d-flex gap-2">
                    <button className="btn btn-outline-success fw-medium rounded-pill" onClick={onSendMessage}>
                        <i className="bi bi-chat-fill"></i> Send Message
                    </button>
                    <button className="btn btn-green" disabled title="Booking arrives with Sessions">
                        <span>
                            <i className="bi bi-calendar-check-fill"></i> Book a Session
                        </span>
                    </button>

                    
                </div>
            </div>
            
        </>
    );
};

export default MenteeMyMentorHeader;
